<template>
  <v-app id="inspire">
    <v-dialog
      v-model="showUpdateVersionModal"
      v-if="showUpdateVersionModal"
      persistent
      width="450px"
    >
      <z-modal-update-version />
    </v-dialog>
    <offline-modal :opened="!isOnline" />

    <router-view />

    <div
      class="version-wrapper"
      style="
        position: absolute;
        bottom: 0;
        right: 0;
        margin: 2px;
        display: none;
      "
    >
      v.: {{ version }}
      <div class="build-wrapper" style="display: none">Build: {{ build }}</div>
    </div>
  </v-app>
</template>

<script>
// import { version, build } from "./version.json";
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import router from "@/middlewares/router";
import CompanyService from "./service/company-service";
import { zModalUpdateVersion } from "zoox-components";
import OfflineModal from "@/components/shared/OfflineModal/OfflineModal.vue";

export default {
  components: {
    zModalUpdateVersion,
    OfflineModal
  },
  provide() {
    return {
      isOnline: this.isOnline
    };
  },
  data() {
    return {
      version: "0.1.0",
      build: "None",
      companyservice: new CompanyService(),
      customizationSet: {},
      showUpdateVersionModal: false,
      isOnline: true
    };
  },
  computed: {
    ...mapState(["pushNotificationService"])
  },
  async mounted() {
    window.addEventListener("online", () => {
      this.isOnline = true;
    });
    window.addEventListener("offline", () => {
      this.isOnline = false;
    });

    // fix android navbar problem
    window.scrollTo(0, 0);
    Vue.$globalEvent.$on("mediaNotSupported", () => {
      this.$setMediaNoSupport();
    });

    const company = this.companyservice.getLocalCompany();

    const customization = company.parameters_sc.operation_flow || {};
    Vue.prototype.$customization = customization;

    const colorCustomization = {
      "--button-color": this.customizationSet.buttonColor,
      "--button-background-color": this.customizationSet.buttonColor,
      "--button-color--hover": this.customizationSet.hoverButtonColor,
      "--button-background-color--hover": this.customizationSet
        .hoverButtonColor,
      "--v-button-text-color": this.customizationSet.buttonTextColor,
      "--steps-color": this.customizationSet.stepsColor,
      "--steps-text-color": this.customizationSet.stepsTextColor
    };

    Vue.prototype.$colorCustomization = colorCustomization;

    if (customization.enableCheckin === false) {
      router.push({ name: "CheckInDisabled" });
    }
    this.$vuetify.theme.primary = this.customizationSet.buttonColor;
    this.$vuetify.theme.accent = this.customizationSet.buttonColor;

    this.checkIfIsIosDevice();

    // TODO: feature p/ enviar notificação push
  },
  sockets: {
    connect: function() {
      // eslint-disable-next-line no-console
      console.log("socket connected");
    },
    "update-version": function() {
      this.showUpdateVersionModal = true;
    }
  },
  async created() {
    const company = this.companyservice.getLocalCompany();
    this.customizationSet = await this.companyservice.getCustomizationSettings(
      company.subdomain
    );
  },
  methods: {
    ...mapActions(["$setMediaNoSupport"]),
    checkIfIsIosDevice() {
      const ret =
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod"
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document);

      if (ret === true) {
        document.querySelector(".v-dialog").style.removeProperty("min-height");

        const style = document.createElement("style");
        document.head.appendChild(style);
        style.sheet.insertRule(
          ".v-dialog__content {display: block; overflow: auto}"
        );

        style.sheet.insertRule(
          ".v-dialog {width: 90% !important; min-height: auto !important}"
        );
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/index.scss";
@import "@/scss/reset-novo-fluxo.scss";
</style>
